import React from 'react';

export const Tab = ({
  name = '',
  label = '',
  isFirst = false,
  selected = false,
  onClick: handleClick = () => {}
}) => (
  <div
    className={`
      patient-chart-tab
      p-l-2
      p-r-2
      min-width-130
      height-30
      flex
      align-items-center
      justify-content-center
      ${isFirst ? 'first' : ''}
      ${selected ? 'selected' : ''}
    `}
    onClick={handleClick.bind(this, name)}
  >
    {label}
  </div>
);

export default Tab;
